import React from 'react'

const DatePickerIcon = React.forwardRef(({value, onClick, disable},ref)=>{
   // <i className="icon-calendar"/>  {value}
    return <button className="btn btn-primary ml-1"
                   onClick={(e)=>{
                        let button_disable = disable === undefined ? false : disable
                           if(button_disable === true)
                           {
                               return null
                           } else {
                               return onClick(e)
                           }
                        }
                    }
                   ref={ref}
                   disable={disable === undefined ? false : disable}>
        <i className="icon-calendar"/>
    </button>
})

export default DatePickerIcon
